// extracted by mini-css-extract-plugin
module.exports = {"button":"folders_button__3CFqx","headFont":"folders_headFont__3nczP","modalFolder":"folders_modalFolder__2RdjJ","modalBody":"folders_modalBody__2QWsQ"};